import {
    FaBalanceScale,
    FaBoxes,
    FaCheck,
    FaClipboardList,
    FaHome,
    FaIdCard,
    FaShieldAlt,
    FaUniversity,
} from "react-icons/fa";

const Frame = ({ children }) => (
    <div className="rounded-2xl border border-gray-200 bg-white p-6 shadow-lg">
        {children}
    </div>
);

const Row = ({ label, pill, pillClass }) => (
    <div className="flex items-center justify-between border-b border-gray-200 py-3 text-sm text-gray-600 last:border-b-0">
        <span>{label}</span>
        <span className={`rounded-full px-2.5 py-1 text-[11px] font-semibold ${pillClass}`}>{pill}</span>
    </div>
);

const PILL_NAVY = "bg-secondaryExtraLight/60 text-secondary";
const PILL_GOLD = "bg-accent/25 text-secondaryDark";

const documents = [
    { Icon: FaIdCard, label: "Justificatif d'identité — moins de 3 mois" },
    { Icon: FaUniversity, label: "Relevé d'identité bancaire" },
    { Icon: FaCheck, label: "Validation numérique d'identité" },
    { Icon: FaClipboardList, label: "Questionnaire investisseur (réglementation PSFP)" },
];

export const DocumentsVisual = () => (
    <Frame>
        <div className="flex flex-col gap-2.5">
            {documents.map(({ Icon, label }) => (
                <div key={label} className="flex items-center gap-3 rounded-xl border border-gray-200 p-3">
                    <span className="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-lg bg-secondaryExtraLight/60 text-secondary">
                        <Icon size={14} />
                    </span>
                    <span className="text-xs font-medium text-black">{label}</span>
                </div>
            ))}
        </div>
    </Frame>
);

export const CompaniesVisual = () => (
    <Frame>
        <Row label="Entreprise A — Industrie" pill="Financé" pillClass={PILL_NAVY} />
        <Row label="Entreprise B — Commerce" pill="En cours" pillClass={PILL_GOLD} />
        <Row label="Entreprise C — BTP" pill="Financé" pillClass={PILL_NAVY} />
        <Row label="Entreprise D — Santé" pill="Financé" pillClass={PILL_NAVY} />
    </Frame>
);

const bars = [
    { label: "Artisans", height: "38%", highlighted: false },
    { label: "Restaurants", height: "64%", highlighted: false },
    { label: "Santé", height: "100%", highlighted: true },
    { label: "Industrie", height: "52%", highlighted: false },
    { label: "Immobilier", height: "74%", highlighted: false },
];

export const AllocationVisual = () => (
    <Frame>
        <div className="mb-2 flex items-end gap-2">
            {bars.map(({ label, height, highlighted }) => (
                <div key={label} className="flex flex-1 flex-col items-center gap-2">
                    <div className="flex h-32 w-full items-end">
                        <span
                            style={{ height }}
                            className={`w-full rounded-t-md ${
                                highlighted
                                    ? "bg-gradient-to-b from-accent to-yellow-500"
                                    : "bg-gradient-to-b from-secondaryLight to-secondary"
                            }`}
                        />
                    </div>
                    <span className="text-center text-[10px] leading-tight text-gray-600">{label}</span>
                </div>
            ))}
        </div>
        <div className="border-t border-gray-200 pt-3">
            <Row label="Répartition sectorielle" pill="Boost" pillClass={PILL_GOLD} />
        </div>
    </Frame>
);

const securities = [
    { Icon: FaShieldAlt, label: "Caution dirigeant" },
    { Icon: FaHome, label: "Hypothèque rang 1" },
    { Icon: FaBalanceScale, label: "Caution notariée" },
    { Icon: FaBoxes, label: "Gage sur stock" },
];

export const SecurityVisual = () => (
    <Frame>
        <div className="grid grid-cols-2 gap-2.5">
            {securities.map(({ Icon, label }) => (
                <div key={label} className="rounded-xl border border-gray-200 p-4 text-center">
                    <Icon className="mx-auto mb-2 text-secondary" size={20} />
                    <span className="block text-[11px] leading-tight text-gray-600">{label}</span>
                </div>
            ))}
        </div>
    </Frame>
);

export const RiskCostVisual = () => (
    <Frame>
        <div className="py-4 text-center">
            <p className="text-4xl font-bold text-secondary">1,84 %</p>
            <p className="mt-1 text-xs text-gray-600">Coût du risque moyen constaté sur 10 ans</p>
        </div>
    </Frame>
);

export const ReinvestVisual = () => (
    <Frame>
        <Row label="Échéance — Juin 2026" pill="Réinvestie" pillClass={PILL_NAVY} />
        <Row label="Échéance — Juillet 2026" pill="Réinvestie" pillClass={PILL_NAVY} />
        <Row label="Échéance — Août 2026" pill="Disponible" pillClass={PILL_GOLD} />
    </Frame>
);
